import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',//首页
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/city',//城市选择页面
    name: 'city',
    component: () => import('../views/home/city.vue')
  },
  {
    path: '/article/detail/:id',//文档页面
    name: 'articleDetail',
    component: () => import('../views/article/article.vue')
  },
  {
    path: '/shop/detail/:id',//亿起购详情页
    name: 'goodsDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/mall/detail.vue')
  },
  {
    path: '/shop/cart',//购物车
    name: 'cart',
    component: () => import('../views/mall/cart.vue')
  },
  {
    path: '/shop/list/:cat/:keyword',//亿起购列表
    name: 'shopList',
    component: () => import('../views/mall/list.vue')
  },
  {
    path: '/shop/createorder/:id/:checkfrom',//亿起购生成订单
    name: 'createOrder',
    component: () => import('../views/mall/createOrder.vue')
  },
  {
    path: '/shop/merchant/:id',//商户
    name: 'shopMerchant',
    component: () => import('../views/mall/merchant.vue')
  },
  {
    path: '/shop/category/:cat',//分类
    name: 'shopCategory',
    component: () => import('../views/mall/category.vue')
  },
  {
    path: '/login',//登录页面
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/user',//用户中心
    name: 'userCenter',
    component: () => import('../views/user/userCenter.vue')
  },
  {
    path: '/user/addressadd/:id',//地址管理
    name: 'addressAdd',
    component: () => import('../views/user/addressAdd.vue')
  },
  {
    path: '/user/addresslist',//收货地址列表
    name: 'addressList',
    component: () => import('../views/user/addressList.vue')
  },
  {
    path: '/user/orderlist/:status',//订单列表
    name: 'orderlist',
    component: () => import('../views/user/orderList.vue')
  },
  {
    path: '/user/orderdetail/:module/:id',//订单详情
    name: 'orderDetail',
    component: () => import('../views/user/orderDetail.vue')
  },
  {
    path: '/user/ordercomment/:module/:id/:goodsid',//订单评论
    name: 'orderComment',
    component: () => import('../views/user/orderComment.vue')
  },
  {
    path: '/user/money',//支付记录
    name: 'money',
    component: () => import('../views/user/money.vue')
  },
  {
    path: '/user/yaoqing',//邀请有奖
    name: 'yaoqing',
    component: () => import('../views/user/yaoqing.vue')
  },
  {
    path: '/user/tixian',//提现列表
    name: 'tixian',
    component: () => import('../views/user/tixian.vue')
  },
  {
    path: '/user/coupon',//我的优惠券
    name: 'coupon',
    component: () => import('../views/user/coupon.vue')
  },
  {
    path: '/user/collection',//我的收藏
    name: 'collection',
    component: () => import('../views/user/collection.vue')
  },
  {
    path: '/user/jianyi',//建议有奖
    name: 'jianyi',
    component: () => import('../views/user/jianyi.vue')
  },
  {
    path: '/user/yuyue',//我的预约
    name: 'yuyue',
    component: () => import('../views/user/yuyue.vue')
  },
  {
    path: '/user/second',//闲置
    name: 'mysecond',
    component: () => import('../views/user/second.vue'),

  },
  {
    path: '/user/fenxiang/index',//分享
    name: 'fenxiangIndex',
    component: () => import('../views/user/fenxiang/index.vue')
  },
  {
    path: '/second/list',//闲置列表
    name: 'secondList',
    component: () => import('../views/second/list.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/second/detail/:id',//闲置详情
    name: 'secondDetail',
    component: () => import('../views/second/detail.vue')
  },
  {
    path: '/second/add',//发布闲置
    name: 'secondAdd',
    component: () => import('../views/second/add.vue')
  },
  {
    path: '/hui/list',
    name: 'huiList',
    component: () => import('../views/hui/list.vue')
  },
  {
    path: '/hui/detail/:id',
    name: 'huiDetail',
    component: () => import('../views/hui/detail.vue')
  },
  {
    path: '/hui/createorder/:id',
    name: 'createOrderHui',
    component: () => import('../views/hui/createOrder.vue')
  },
  {
    path: '/qiang/list',//一起抢列表
    name: 'qiangList',
    component: () => import('../views/qiang/list.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/qiang/detail/:id',//一起抢详情
    name: 'qiangDetail',
    component: () => import('../views/qiang/detail.vue')
  },
  {
    path: '/qiang/createorder/:id/',//一起抢生成订单
    name: 'createOrderQiang',
    component: () => import('../views/qiang/createOrder.vue')
  },
  {
    path: '/community/index',//亿起汇
    name: 'communityIndex',
    component: () => import('../views/community/index.vue')
  },
  {
    path: '/community/community',//社区
    name: 'community',
    component: () => import('../views/community/community.vue')
  },
  {
    path: '/cps/order',//外站的cps
    name: 'cpsOrder',
    component: () => import('../views/cps/ordersList.vue')
  },
  {
    path: '/cps/goodsList',//外站的cps
    name: 'cpsGoodsList',
    component: () => import('../views/cps/goodsList.vue')
  },

]

const router = new VueRouter({
  //   mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
